import type { ReactNode } from 'react';
import { MagazineTrackContainer } from './MagazineTrackContainer';

type MagazineBodyProps = {
  children: ReactNode;
  header: ReactNode;
  aside: ReactNode;
};

function MagazineBody({ children, header, aside }: MagazineBodyProps) {
  return (
    <div data-testid="magazine-body" data-track-feature="Magazine">
      <MagazineTrackContainer>
        <div className="ll-container-inner" data-testid="magazine-body-header">
          {header}
        </div>
        <div className="ll-container-inner grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,31%)]">
          <div className="min-w-0" data-testid="magazine-body-main">
            {children}
          </div>
          {aside}
        </div>
      </MagazineTrackContainer>
    </div>
  );
}

export { MagazineBody, type MagazineBodyProps };
